import React from "react";
import { SideMenu, BackHeader } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Countries from "./../../../data/countries";
import { useNavigate } from "react-router-dom";
const OrganizeTripBook = () => {
  const navigate = useNavigate();
  const [countryCode, setCountryCode] = React.useState("");
  const handleDropdownChange = (e) => {
    setCountryCode(e.target.value);
    console.log(e.target.value);
  };
  const State = [
    {
      title: "Balochistan",
    },
    {
      title: "Punjab",
    },
    {
      title: "Sindh",
    },
    {
      title: "KPK",
    },
  ];
  return (
    <SideMenu>
      <div className="page-details-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <p className="page-form-heading">Trip registretion form</p>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
              <div>
                <p className="input-heading">First Name</p>
                <input
                  type="text"
                  className="input"
                  placeholder="enter your first name"
                />
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
              <div>
                <p className="input-heading">last Name</p>
                <input
                  type="text"
                  className="input"
                  placeholder="enter your last name"
                />
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
              <div>
                <p className="input-heading">Email ID</p>
                <input
                  type="text"
                  className="input"
                  placeholder="Enter email ID"
                />
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
              <div>
                <p className="input-heading">Country</p>
                <select className="input">
                  <option value="">Country</option>
                  {Countries.map((countriesValue, countriesIndex) => {
                    return (
                      <option key={countriesIndex} value={countriesValue.name}>
                        {countriesValue.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
              <div>
                <p className="input-heading">State</p>
                <select className="input">
                  <option value="">State</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
              <div>
                <p className="input-heading">City</p>
                <select className="input">
                  <option value="">City</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Mobile Number</p>
                <div className="country-code-picker-main">
                  <div className="country-code-picker-dropdown-main">
                    <select
                      className="country-code-picker-dropdown"
                      onChange={handleDropdownChange}
                    >
                      <option value="">Select</option>
                      {Countries.map((countriesValue, countriesIndex) => {
                        return (
                          <option
                            key={countriesIndex}
                            value={countriesValue.alpha2Code}
                          >
                            {`${countriesValue.callingCode}  ${countriesValue.name}`}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="country-flag-main">
                    {Countries.map((countriesFlagValue, countriesFlagIndex) => {
                      return (
                        <div key={countriesFlagIndex}>
                          {countriesFlagValue.alpha2Code === countryCode && (
                            <img
                              src={countriesFlagValue.flag}
                              className="country-flag"
                            />
                          )}
                        </div>
                      );
                    })}

                    <input
                      type="number"
                      className="mobile-number-input"
                      placeholder="Enter your mobile number"
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <Button
                className="form-button"
                variant="text"
                onClick={() => navigate(-1)}
              >
                Pay now
              </Button>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
          </Grid>
        </Box>
      </div>
    </SideMenu>
  );
};
export default OrganizeTripBook;
